import { useState } from 'react';
import { useEffect } from 'react';
import styled from 'styled-components';
import query from '../../server/constants.api';
import useMultipleFetch from '../../server/useMultipleFetch';
import { weatherSerializer } from '../../utils/serializers/weatherSerializer';
import Spinner from '../Global/Atomics/Spinner';
import { WidgetCard } from '../Global/Atomics/WidgetCard';
import CustomIcon from '../Global/Icons/CustomIcon';
import Theme from '../../styles/Theme/Theme';
import { Text } from '../Global/Atomics/Text';


const ForcastHour = styled.div`
    display: ${props => (props.display ? props.display : 'flex')}; 
    flex-direction: column; 
    align-Items: flex-end;
    margin-left: ${Theme.spacing.desktop.xs};
    @media ${Theme.devices.videowall} {
        margin-left: ${Theme.spacing.videowall.sm}
    }
`;

export const WeatherWidget = () => {
    const months = ["January", "Febuary", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const newDate = new Date().getHours() + ':' + String(new Date().getMinutes()).padStart(2, "0");
    const month = months[new Date().getMonth()];

    const [actualDate, setActualDate] = useState(newDate);
    const [actualMonth, setActualMonth] = useState(month);
    const [proccessData, setProccessData] = useState(null);
    

    let start_date_current = Math.floor(new Date().getTime() / 1000) - 3600;
    const weatherQueryResults = useMultipleFetch([
        { path: query.path.currentWeather, params: { tenant: 'Cascais', start_date: start_date_current.toString() }, id: 'getCurrentWeather' },
        { path: query.path.forecastWeather, params: { tenant: 'Cascais', start_date: start_date_current.toString() }, id: 'getForecastWeather' }
    ]);

    useEffect(() => {
        if (!weatherQueryResults[0]?.isLoading && !weatherQueryResults[1]?.isLoading) {
            const serializedData = weatherSerializer(weatherQueryResults[0]?.data?.data, weatherQueryResults[1].data?.data);
            setProccessData(serializedData);
        }
    }, [weatherQueryResults[0]?.isLoading, weatherQueryResults[1]?.isLoading]);

    useEffect(() => {
        setInterval(()=>{
            const newDate = new Date().getHours() + ':' + String(new Date().getMinutes()).padStart(2, "0");
            const month = months[new Date().getMonth()];
            setActualDate(newDate);
            setActualMonth(month);
        }, 30000);
    }, []);

    return (
        <WidgetCard backgroundColor={Theme.color['blue-7']} display='flex' flexDirection='column' padding={Theme.spacing.videowall.md} margin={Theme.spacing.videowall.xxs} style={{ color: 'white' }}>
            {proccessData !== null ?
                <>
                    <div style={{ display: 'flex', height: '60%', justifyContent: 'space-between', marginBottom: '24px' }}> 
                    {/* Margin bottom not variable */}
                        <div style={{ display: 'flex', placeItems: 'center', alignSelf: 'baseline' }}>
                            <Text fontSize='text_xxxl' marginRight={Theme.spacing.videowall.sm} fontWeight={Theme.typography.weight.light}>{actualDate}</Text>
                            <CustomIcon icon={proccessData.currentTemperatureIcon} iconSize='md' color={Theme.color['teal-3']} />
                            <Text fontSize='text_xl' marginLeft={Theme.spacing.videowall.xxs} fontWeight={Theme.typography.weight.light}>{proccessData.temperature}º</Text>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <ForcastHour display={proccessData.firstHour ? null : 'none'}>
                                <Text fontSize='text_xl' fontWeight={Theme.typography.weight.light} marginBottom= {Theme.spacing.videowall.xxxs} >+1h</Text>
                                <div style={{ display: 'flex', alignItems: 'center'}}><CustomIcon icon={proccessData.firstHourIcon} iconSize='md' color={Theme.color['teal-3']} /><Text fontSize="text_xl" marginLeft={Theme.spacing.videowall.xxs}>{proccessData.firstHour}</Text></div>
                            </ForcastHour>
                            <ForcastHour display={proccessData.secondHour ? null : 'none'}>
                                <Text fontSize='text_xl' fontWeight={Theme.typography.weight.light} marginBottom= {Theme.spacing.videowall.xxxs}>+2h</Text>
                                <div style={{ display: 'flex', alignItems: 'center'}}><CustomIcon icon={proccessData.secondHourIcon} iconSize='md' color={Theme.color['teal-3']} /><Text fontSize="text_xl" marginLeft={Theme.spacing.videowall.xxs}>{proccessData.secondHour}</Text></div>
                            </ForcastHour>
                            <ForcastHour margin='0px 0px 8px 38px' display={proccessData.thirdHour ? null : 'none'}>
                                <Text fontSize='text_xl' fontWeight={Theme.typography.weight.light} marginBottom= {Theme.spacing.videowall.xxxs}>+3h</Text>
                                <div style={{ display: 'flex', alignItems: 'center'}}><CustomIcon icon={proccessData.thirdHourIcon} iconSize='md' color={Theme.color['teal-3']} /><Text fontSize="text_xl" marginLeft={Theme.spacing.videowall.xxs}>{proccessData.thirdHour}</Text></div>
                            </ForcastHour>
                        </div>
                    </div>
                    <div style={{ display: 'flex', height: '40%', justifyContent: 'space-between', alignItems: 'self-end' }}>
                        <Text fontSize='text_xxl' color={Theme.color['blue-1']} margin='0' fontWeight={Theme.typography.weight.medium}>{proccessData.city}</Text>
                        <Text fontSize='text_xl' color={Theme.color['white']} margin='0' fontWeight={Theme.typography.weight.light}>{actualMonth}</Text>
                    </div>
                </>
                : <div style={{ height: 'inherit', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}><Spinner stroke="green" /></div>}
        </WidgetCard>
    );
};